import React, { createContext, useReducer } from "react";
import { PVAOverviewReducer } from "../reducers/PVAOverviewReducer";

export const PVAOverviewContext = createContext();

const PVAOverviewContextProvider = (props) => {
  const pvaOverviewData = {
    pvaTableData: {
      granularity: "60",
    },
    pvaGraphData: {
      granularity: "15",
      processName: ["induct"],
    },
    overviewData: {},
    performance: {},
    inbound: {},
    pick: {},
    stage: {},
    wip: {},
    processPathAggregateData: {},
    shiftPlans: [],
    dynamicShiftPlans: {
      latest: null,
      master: null,
    },
    targetData: {
      INDUCT_FPH: "0",
      STOW_FPH: "0",
      INDUCT_PPH: "0",
      STOW_PPH: "0",
      NODE_TPH: "0",
      PICK_FPH: "0",
      STAGE_FPH: "0",
      cycleId: "",
      dayOfTheWeek: "",
    },
    wipTargetData: {
      WIP_TARGET: "90",
      STOW_WIP_UPPER: "30",
      STOW_WIP_LOWER: "15",
    },
    pphData: {},
  };
  const [pvaData, dispatch] = useReducer(PVAOverviewReducer, pvaOverviewData);
  return (
    <PVAOverviewContext.Provider value={{ pvaData, dispatch }}>
      {props.children}
    </PVAOverviewContext.Provider>
  );
};

export default PVAOverviewContextProvider;



// WEBPACK FOOTER //
// ./src/components/overview/context/PVAOverviewContext.js